import React, {useRef} from "react"
import styles from "./index.module.scss"

interface IRepoName {
  ownerName: string
  repoId: string
  onSave: (name: string) => void
}

/**
 * To avoid confusion, users can change only the Index ***NAME*** via UI
 */
export const RepoName: React.FC<IRepoName> = ({ownerName, repoId: originalRepoId, onSave}) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  return (
    <div className={styles.Section}>
      <div className={styles.SubHeader}>
        Repository name
      </div>

      <div className={styles.Content}>
        <label>
          @{ownerName} /
        </label>
        <input
          type="text"
          className={styles.TextInput}
          ref={inputRef}
          defaultValue={originalRepoId}
        />
        <button className={styles.InfoBtn}
                onClick={() => inputRef.current && onSave(inputRef.current.value)}>
          Save
        </button>
      </div>
    </div>
  )
}
